import mapboxgl from 'mapbox-gl';

export function createMap(options) {
    mapboxgl.accessToken = mapboxSettings.accessToken;

    return new mapboxgl.Map({
        style: 'mapbox://styles/eventconnectors/cml7thwbn000301qzaw4f0b4p',
        ...options
    });
}

export function createLandmarks(map, markers, bounds) {
    const locations = document.querySelectorAll('.map-location');

    if (!locations.length) {
        return;
    }

    locations.forEach(location => {
        const { lat, lng, url } = location.dataset;
        
        const marker = document.createElement('a');
        marker.className = 'map-marker map-landmark';
        marker.dataset.label = location.dataset.label;
        marker.href = url;

        const label = document.createElement('span');
        label.className = 'map-landmark-label';
        label.textContent = location.dataset.label;
        marker.appendChild(label);

        markers.push(new mapboxgl.Marker(marker).setLngLat([lng, lat]).addTo(map));
        bounds.extend([lng, lat]);
    });
}

export function renderRoute(canvas) {
    const zoomOutButton = canvas.parentElement.querySelector('.map-action.zoom-out');
    const zoomInButton = canvas.parentElement.querySelector('.map-action.zoom-in');

    const settings = JSON.parse(canvas.dataset.settings);
    const { calculatedCoordinates, routeCoordinates, pois, center, zoom = 12 } = settings;

    const map = createMap({
        container: canvas,
        center: center,
        zoom: zoom
    });
    
    map.scrollZoom.disable();
    map.dragPan.enable();

    map.on('load', () => {
        map.addSource('Line', {
            'type': 'geojson',
            'data': toGeoJsonFeatureCollection(calculatedCoordinates),
        });

        map.addLayer({
            'id': 'Line',
            'type': 'line',
            'source': 'Line',
            'layout': {
                'line-join': 'round',
                'line-cap': 'round'
            },
            'paint': {
                'line-color': '#D92E20',
                'line-width': 5
            }
        });

        const bounds = new mapboxgl.LngLatBounds(
            calculatedCoordinates[0],
            calculatedCoordinates[0]
        );

        for (const coord of calculatedCoordinates) {
            bounds.extend(coord);
        }

        // Add route coordinates as markers
        routeCoordinates.forEach(coord => {
            const el = document.createElement('div');
            el.className = 'map-marker';

            const marker = new mapboxgl.Marker(el)
                .setLngLat(coord)
                .addTo(map);

            bounds.extend(coord);
        });

        // Add POI markers with a text label for the title
        pois.forEach(poi => {
            const markerElement = document.createElement('div');
            markerElement.className = 'map-marker map-marker-solid';
            markerElement.innerHTML = `<i class="${poi.icon}"></i>`;

            const marker =new mapboxgl.Marker(markerElement)
                .setLngLat([poi.lng, poi.lat])
                .addTo(map);

            const popupElement = document.createElement('div');
            popupElement.className = 'map-popup';
            popupElement.innerHTML = `<h3>${poi.title}</h3><p>${poi.description}</p>`;

            const popup = new mapboxgl.Popup({
                offset: 15,
                closeButton: false,
                closeOnClick: false
            }).setLngLat([poi.lng, poi.lat])
              .setDOMContent(popupElement);

            marker.getElement().addEventListener('mouseenter', () => popup.addTo(map));
            marker.getElement().addEventListener('mouseleave', () => popup.remove());

            bounds.extend([poi.lng, poi.lat]);
        });

        map.fitBounds(bounds, {
            padding: 40
        });
    });

    zoomOutButton.addEventListener('click', () => {
        map.zoomOut();
    });

    zoomInButton.addEventListener('click', () => {
        map.zoomIn();
    });

    return map;
}

function toGeoJsonFeatureCollection(coordinates) {
    return {
        type: 'FeatureCollection',
        features: [
            {
                type: 'Feature',
                geometry: {
                    type: 'LineString',
                    coordinates: coordinates
                },
                properties: {}
            }
        ]
    };
}